import React from 'react';

import ModelsFilter from './components/ModelsFilter';
import {
  ParamsFilterNew,
  ParamsFilterAmp,
  ParamsFilterElectric,
  ParamsFilterCommercial,
  ParamsFilterAll,
} from './components/ParamsFilter';
import { FiltersProps } from './types';
import { ParamsFilterHybrid } from './components/ParamsFilter/ParamsFilterHybrid';

function Filters({ carsType }: FiltersProps) {
  return (
    <React.Fragment>
      <ModelsFilter carsType={carsType} />
      {carsType === 'new' ? (
        <ParamsFilterNew />
      ) : carsType === 'amp' ? (
        <ParamsFilterAmp />
      ) : carsType === 'electric' ? (
        <ParamsFilterElectric />
      ) : carsType === 'commercial' ? (
        <ParamsFilterCommercial />
      ) : carsType === 'hybrid' ? (
        <ParamsFilterHybrid />
      ) : (
        <ParamsFilterAll />
      )}
    </React.Fragment>
  );
}

export default Filters;
